/**
 * @desc This can be used to vertically align a csIcon element
 * @example <span><span cs-icon-container><i cs-icon="warning"></i></span></span>
 */
;(function () {
  'use strict'

  angular
    .module('contrast.icons')
    .directive('csIconContainer', [csIconContainer])

  function csIconContainer() {
    return {
      restrict: 'A',
      link: function (scope, elem) {
        elem.addClass('cs-icon-container')
      }
    }
  }
})()
